import { signal } from "alien-signals";
import { BookInfoModel } from "../models/BookInfoModel.js";

export const bookInfo = signal(new BookInfoModel({}));
export const retailers = signal([]);

export function setBookInfo(config) {
  // Setup used to throw when an embedder omitted bookInfo.
  bookInfo(new BookInfoModel(config || {}));
}
